module.exports = __webpack_public_path__ + "img/default.6c8c3b87.png";